export const userColumnsConfig = {
  GENDER: "Gender",
  NAME: "FIRSTNAME",
  LAST: "LASTNAME",
  EMAIL: "Email",
  SOCIAL_TYPE: "Login Type",
  COUPLE_STATUS: "Couple Status",
  STATUS: "Status",
  ACTIONS: "Actions",
  messages: "Are you sure you want to delete this user?",
};